<template lang="pug">
el-dialog(v-dialog-drag, width="640px", :title="title", :visible.sync="visible", @closed="reject", :close-on-click-modal="false")
  el-button-group
    el-button(type="primary", plain, @click="addRow") 添加一行
    el-button(type="primary", plain, @click="removeRow") 删除选中
    el-button(type="primary", plain, @click="autoMatch") 自动匹配
  el-table(size="mini", ref="table", highlight-current-row, height="350px", border, :data="data")
    el-table-column(type="selection", width="50px", align="center")
    el-table-column(v-slot="{ row }", label="Excel列", prop="label", align="center")
      el-select(v-model="row.label", size="small", filterable)
        el-option(v-for="label in excelHeader", :key="label", :value="label")
    el-table-column(v-slot="{ row }", label="目标字段", align="center")
      el-select(v-model="row.field", size="small", filterable)
        el-option(v-for="item in fields", :key="item.columnName", :label="item.columnDisplayName", :value="item.columnName")
    el-table-column(label="字段标识", prop="field")
  template(#footer)
    el-button(size="small", @click="close") 取消
    el-button(size="small", type="primary", @click="submit") 确定
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import { difference } from "lodash-es";
export default {
  mixins: [asyncMixin],
  props: {
    title: { default: "数据关联", type: String },
    excelHeader: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return { visible: true, data: [] };
  },
  computed: {
    submitData() {
      return this.data.filter(({ label, field }) => label && field);
    }
  },
  methods: {
    async autoMatch() {
      const { data, excelHeader, fields } = this;
      if (data.length) await this.$confirm("此操作将覆盖当前的配置,确定继续?", "警告", { type: "warning" });
      const list = [];
      const map = {};
      for (const { columnDisplayName, columnName } of fields) {
        map[columnDisplayName] = columnName;
      }
      for (const label of excelHeader) {
        const field = map[label];
        if (!field) continue;
        map[field] = undefined;
        list.push({ field, label });
      }
      this.data = list;
    },
    addRow() {
      this.data.push({ field: "", label: "" });
    },
    async removeRow() {
      const {
        data,
        $refs: {
          table: { selection }
        }
      } = this;
      await this.$confirm("确定移除选中数据?", "警告", { type: "warning" });
      this.data = difference(data, selection);
    },
    close() {
      this.visible = false;
    },
    submit() {
      this.resolve(this.submitData);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button-group {
  margin: 0 0 4px;
}
</style>
